import {
    PORTOPEN
} from '../types';

export function portopenaction(status) {
    return {
        type: PORTOPEN,
        status
    }
}